<!--
 * @Description  :
 * @Author       : wang_shuai
 * @Date         : 2023-05-22 08:57:31
 * @LastEditors  : zcc
 * @LastEditTime : 2025-04-23 15:22:22
 * @FilePath     : \ngs_platform_manage_admin\src\components\dropdown\dropdown.vue
-->
<!-- dropdown -->
<template>
  <el-dropdown @command="handleCommand">
    <span class="el-dropdown-link">
      <span>{{ activeLevel.label }}</span>
      <svg-icon class="sanjiao_fill" icon-class="sanjiao_fill"></svg-icon>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        :command="item"
        v-for="item in levelList"
        :key="item.value"
      >
        {{ item.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  props: {
    levelList: {
      type: Array,
      default: () => []
    },
    largeLevel: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      activeLevel: {
        label: "展开到一级",
        value: 1
      }
    };
  },
  computed: {},
  watch: {
    levelList: {
      handler: function(value) {
        if (this.largeLevel && value.length > 0) {
          this.activeLevel = value[value.length - 1];
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.largeLevel && this.levelList.length > 0) {
      this.activeLevel = this.levelList[this.levelList.length - 1];
    }
  },
  mounted() {},
  methods: {
    handleCommand(item) {
      this.activeLevel = item;
      this.$emit("levelChange", this.activeLevel);
    }
  }
};
</script>

<style lang="less" scoped>
.el-dropdown-link {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 16px;
}
.sanjiao_fill {
  transform: rotateZ(180deg);
  margin-left: 6px;
  fill: #3ba1ff;
}
</style>
